import { DashboardMainContainer } from '@/modules/Dashboard';

const Dashboard = (): JSX.Element => <DashboardMainContainer />;

export default Dashboard;
